import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-earning-report-export',
  templateUrl: './earning-report-export.component.html',
  styleUrls: ['./earning-report-export.component.scss']
})
export class EarningReportExportComponent implements OnInit {
  start: any;
  end: any;
  startDateCustom: string;
  endDateCustom: string;
  retailerUniqueName: string;
 retailerFirstName:any;
 service:any;
 services = [
  { serviceName: 'AePS', value: 'aeps' },
  { serviceName: 'DMT', value: 'dmt' },
  { serviceName: 'Move to Bank', value: 'bank' },
  { serviceName: 'CMS', value: 'cms' },
  { serviceName: 'Recharge', value: 'recharge' },
  { serviceName: 'Mirco ATM', value: 'microatm' }
]
  constructor(private ngxService: NgxUiLoaderService,private router:Router,private datePipe: DatePipe,private auth: AuthService, private toast: ToastrService,) { }

  ngOnInit(): void {
    this.retailerUniqueName = localStorage.getItem('uniqueName');
    var currentUserDetails = JSON.parse(localStorage.getItem('currentUser'));
    this.retailerFirstName=localStorage.getItem('retailorName');
  }
  searchByDateRange() {
    var Startdate = this.datePipe.transform(this.start, "yyyy-MM-dd");
    var Enddate = this.datePipe.transform(this.end, "yyyy-MM-dd");
    // var ret="YMY3606";
    if(Startdate !=null && Enddate!=null && this.service!=null ){
    this.ngxService.start();

      this.auth.getEarningExcel(this.service,this.retailerUniqueName,Startdate,Enddate).subscribe((res: any) => {
      this.ngxService.stop();

        const blob: any = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if(blob.size>251){
          let link = document.createElement("a");
  
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download","Earning Report "+ "("+this.retailerFirstName+ ")"+this.retailerUniqueName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        
        }else{
          this.toast.error("No Transaction record found");
          this.ngxService.stop();
  
        }
       },
      (err) => {
        this.toast.error(err.error.message);
        this.ngxService.stop();
  
      }
    );
    }else{
      this.toast.error("Please fill all the mandatory field");
      this.ngxService.stop();

    }
 

}
OpenList(){
  this.router.navigate(['dashboard']);
}
}
